export const NUMBER_OF_USERS_CERTIFIED = 200000;
export const USAGE_TRACKER_NAMESPACE = 'learning-center';